import { render, staticRenderFns } from "./CustomizeAvatarButton.vue?vue&type=template&id=627d38ed&"
import script from "./CustomizeAvatarButton.vue?vue&type=script&lang=js&"
export * from "./CustomizeAvatarButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports